import React from "react";
import moment from "moment";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { withStyles } from "@material-ui/core/styles";

import "./ViewDetailComponent.css";

import API_CONFIG from "@safecv/src/api-config";

const StyledMenuItem = withStyles({
  root: {
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
})(MenuItem);

const ViewDetailComponent = (props) => {
  const { headerHeight, planDetails } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <div className="header-view-details" onClick={handleClick}>
        View Details
      </div>
      <Menu
        id="menu"
        keepMounted
        anchorEl={anchorEl}
        onClose={handleClose}
        open={Boolean(anchorEl)}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: headerHeight - headerHeight / 2.7,
          horizontal: "left",
        }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        PaperProps={{
          style: {
            borderRadius: "5px",
          },
        }}
      >
        <StyledMenuItem className="flex-box static-viewdetail">
          <div className="info-index flex-small">Created on</div>
          <div className="date-styl flex-large">
            {moment(planDetails.createdDate).format("MMM DD, YYYY")}
          </div>
        </StyledMenuItem>

        <StyledMenuItem className="flex-box static-viewdetail">
          <div className="info-index flex-small">Submit date</div>
          <div className="date-styl flex-large">
            {moment(planDetails.submitDate).format("MMM DD, YYYY")}
          </div>
        </StyledMenuItem>

        <StyledMenuItem className="flex-box static-viewdetail">
          <div className="info-index flex-small">Due date</div>
          <div className="date-styl flex-large">
            {moment(planDetails.dueDate).format("MMM DD, YYYY")}
          </div>
        </StyledMenuItem>

        <StyledMenuItem className="flex-box static-viewdetail">
          <div className="info-index flex-small">Codebook</div>
          <div className="date-styl flex-large">
            {planDetails.codebookName ? (
              planDetails.codebookName
            ) : (
              <span style={{ color: "#B0B0B0" }}>Disabled</span>
            )}
          </div>
        </StyledMenuItem>

        <StyledMenuItem className="flex-box static-viewdetail">
          <div className="info-index flex-small"> Plan Type </div>
          <div className="date-styl flex-large">{planDetails.planType}</div>
        </StyledMenuItem>

        <StyledMenuItem className="flex-box static-viewdetail">
          <div className="info-index flex-small"> AI Engine </div>
          <div className="date-styl flex-large">{planDetails.algoEnabled ? (
                <span>Enabled</span>
              ) : (
                <span style={{ color: "#B0B0B0" }}>Disabled</span>
            )}
          </div>
        </StyledMenuItem>

        {API_CONFIG.FEATURE_GT_UPLOAD_ENABLED &&
        planDetails.prStatus === "Error" ? (
          <div>
            <span className="info-index flex-small">PR reason for failure</span>
            <span className="date-styl flex-large">
              {planDetails.prReasonForFailure}
            </span>
          </div>
        ) : null}
      </Menu>
    </>
  );
};

export default ViewDetailComponent;
